import { splitMenu } from "./utils/globalFunctions";
shoptet.menu.splitMenu = splitMenu;

import {
  handleCartHeader,
  handleStepBack,
  handleCartDelivery,
  handleCartDiscountCoupon,
  handleCartTableRows,
  addTableHeadToCartTable,
  addOssPriceNotificationCs,
} from "./components/cart";
import { handlePostHeader } from "./components/post";
import { headerInit } from "./components/header";
handleCartHeader();
handleStepBack();
handleCartDelivery();
handleCartDiscountCoupon();
handleCartTableRows();
addTableHeadToCartTable();
addOssPriceNotificationCs();
document.addEventListener("DOMContentLoaded", () => {
  handleCartHeader();
  handleStepBack();
  handleCartDelivery();
  handleCartDiscountCoupon();
  handleCartTableRows();
  addTableHeadToCartTable();
  addOssPriceNotificationCs();
});
document.addEventListener("ShoptetDOMContentLoaded", () => {
  handleCartHeader();
  handleStepBack();
  handleCartDelivery();
  handleCartDiscountCoupon();
  handleCartTableRows();
  addTableHeadToCartTable();
  addOssPriceNotificationCs();
});

if (window.innerWidth >= 768) {
  handlePostHeader();
}
headerInit();
document.addEventListener("DOMContentLoaded", headerInit);

import {
  handleProductTitle,
  handleProductTopFlags,
  handleAddToCartBlock,
  handleProductCode,
  handleShareButton,
  handleProductAvailability,
  // handleProductUSP,
  // handleVIPBanner,
  handleDetailBanner,
  // handleProductGallery,
  handleTabContent,
  // handleRelatedProducts,
  // handleAlternativeProducts,
  handleProductDescriptionClick,
  handleProductCards,
  handleVoteWraps,
  handleMobileProductImage,
  handleDetailFavButton,
  handleDenniDavka,
} from "./components/productDetail";
handleProductTitle();
handleProductTopFlags();
handleAddToCartBlock();
handleProductCode();
// handleShareButton();
handleProductAvailability();
// handleProductUSP();
// handleVIPBanner();
handleDetailBanner();
// handleProductGallery();
handleTabContent();
handleMobileProductImage();
handleProductCards();
handleVoteWraps();
// handleRelatedProducts();
// handleAlternativeProducts();
handleProductDescriptionClick();
handleDetailFavButton();
handleDenniDavka();
